import { render, staticRenderFns } from "./IconMap.vue?vue&type=template&id=b58ff4ba"
import script from "./IconMap.vue?vue&type=script&lang=js"
export * from "./IconMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports